<div style="padding: 20px 0; text-align: center; font-size: 16px">
	<ion-icon class="cross" (click)="modalCtrl.dismiss()" name="close" src="../../../assets/dean_and_david/cross.svg"> </ion-icon>
	<h3 style="margin-bottom: 15px; margin-right: 10px">{{ 'privacy_policy_modal.title' | translate }} 💚</h3>
	<p style="margin-bottom: 15px">
		{{ 'privacy_policy_modal.sub-title' | translate }} <a href="/privacy">{{ 'privacy_policy_modal.here' | translate }}</a>
	</p>
	<p [innerHTML]="'privacy_policy_modal.desc' | translate"></p>
</div>
